module.exports = new __parcel__URL__("Wave3.ea6ec40e.svg").toString();